import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

let queue = [];

export const enqueue = (ev) => {
  queue.push({ ...ev, timestamp: new Date().toISOString() });
  if (queue.length >= 20) flush(false);
};

export const flush = (useBeacon = false) => {
  if (queue.length === 0) return;
  const token = localStorage.getItem('kardif_token');
  if (!token) { queue = []; return; }
  const events = queue;
  queue = [];
  if (useBeacon && navigator.sendBeacon) {
    try {
      const blob = new Blob([JSON.stringify({ events, token })], { type: 'application/json' });
      navigator.sendBeacon(`${API}/activity/track`, blob);
    } catch (e) { /* noop */ }
  } else {
    axios.post(`${API}/activity/track`, { events }).catch(() => {});
  }
};

const ROUTE_LABELS = [
  [/^\/admin$/, 'Tableau de bord Admin'],
  [/^\/admin\/users/, 'Gestion des utilisateurs'],
  [/^\/secretary/, 'Tableau de bord Secrétaire'],
  [/^\/dashboard/, 'Espace terrain'],
  [/^\/planning/, 'Planning'],
  [/^\/intervention\/new/, "Nouvelle intervention"],
  [/^\/intervention\/[^/]+\/edit-report/, "Édition du rapport"],
  [/^\/intervention\//, "Fiche intervention"],
  [/^\/donneurs-ordre/, "Donneurs d'ordre"],
  [/^\/arch-planner/, 'Plan architecte'],
  [/^\/dessin-schema/, 'Schéma'],
  [/^\/statistics/, 'Statistiques'],
  [/^\/search/, 'Recherche'],
  [/^\/factures/, 'Factures'],
  [/^\/activite/, 'Journal / Activité'],
  [/^\/login/, 'Connexion'],
];

export const routeLabel = (path) => {
  for (const [re, label] of ROUTE_LABELS) {
    if (re.test(path)) return label;
  }
  return path;
};
